/**
 * Checks whether the current device uses a coarse pointer (touch, stylus, etc.).
 * Uses `matchMedia` so it's evaluated lazily and respects orientation/device changes.
 */
export function isMobileDevice(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches
}
